import { storeIcon } from '@/lib/map-control/marker/icon';
import { isIncludedCurrentFilter } from '@/lib/map-control/helper';
import { mapControlGetterType } from '@/vuex-store/map-control/getters';
import Marker from './Marker';
export default class StoreMarker extends Marker {
    #type = 'store';
    icon;
    storeId;
    isShareStore;
    /** 상점 이름 */
    name = '';
    constructor(storeData, naver, hubControlMap) {
        super(naver, hubControlMap);
        const { storeId, delayedOrderIds, isShareStore, } = storeData;
        this.id = storeId;
        this.storeId = storeId;
        this.isShareStore = isShareStore;
        this.latLng = [
            storeData.position[0],
            storeData.position[1],
        ];
        this.origin = this.mapControlState.storeList[this.storeId];
        this.name = this.origin.storeName;
        this.icon = storeIcon({
            naver: this.naver,
            storeId,
            name: this.name,
            isShareStore,
            isDelayedStore: !!delayedOrderIds.size,
        });
    }
    deleteMarker() {
        this.mapMarkerList.stores.deleteMarker(this.storeId);
    }
    /**
     * 상점 마커 데이터 업데이트 + 노출 / 비노출 / 제거
     * @param storeData.isActive 활성화 여부
     * @param storeData.isDelete 마커 제거 여부
     * @param storeData.isHide 마커 숨김 여부
     * @returns
     */
    updateMarker({ isActive: _isActive = null, isHide = null, } = {
        _isActive: null,
        isDelete: null,
        isHide: null,
    }) {
        const { storeId, name, } = this;
        const { delayedOrderIds, } = this.mapControlState.storeList[storeId];
        const { isHideShareOrder, isHideStoreMarker, } = this.mapControlState.mapVisibilitySetting;
        this.isActive = typeof _isActive === 'boolean' ? _isActive : this.isActive;
        this.relatedWeight = this.getRelatedWeight();
        // 상점마커 숨김 설정 활성화 시 주문리스트를 클릭해 높인 가중치 정보가 숨김여부보다 우선순위가 높음
        const isShow = this.relatedWeight || (!isHideStoreMarker && !isHide);
        const filteredOrder = Object.values(this.origin.items)
            // 필터 채크
            .filter(({ statusCode }) => {
            // 가중치가 있다면 필터를 무시하고 지도에 노출 되어야 한다. === 상호작용이 있다는 의미
            if (this.relatedWeight) {
                return true;
            }
            return isIncludedCurrentFilter(statusCode, this.selectedOrderFilter);
        })
            // 공유접수상태 채크
            .filter(({ isShareOrder, isAccepted }) => {
            if (isShareOrder && isHideShareOrder && isAccepted) {
                return false;
            }
            return true;
        });
        if (filteredOrder.length > 0 && isShow) {
            this.setMap(this.mapInstance);
        }
        else {
            this.setMap(null);
        }
        // 아이콘 관련 로직
        const iconOptions = storeIcon({
            naver: this.naver,
            storeId,
            name,
            isActive: this.isActive,
            relatedWeight: this.relatedWeight,
            isShareStore: this.isShareStore,
            isDelayedStore: !!delayedOrderIds.size,
        });
        this.setIcon(iconOptions);
    }
    /**
     * 상점 + 도착지 마커 초기화
     * @param isDelete 제거 여부
     * @param isHide 숨김 여부
     */
    deactivateMarker(isDelete, isHide) {
        const { orderList, storeList, } = this.mapControlState;
        const storeData = storeList[this.storeId];
        Object.values(storeData.items).forEach(({ orderId }) => {
            const order = orderList[orderId];
            const mkDrop = this.mapMarkerList.drops.getMarker(orderId);
            const mkWorkerOfAllocatedWorker = this.mapMarkerList.workers.getMarker(order?.allocatedWorkerCode);
            if (!mkDrop) {
                console.log(`[hubControlMap][clearStoreMakrer] not exist drop marker. id ${orderId}`);
                return;
            }
            // 가중치 제거
            this.mapMarkerList.updateOrderMarkerWeight(orderId, true);
            // 주문
            if (isDelete) {
                mkDrop.deleteMarker();
            }
            else {
                mkDrop.unhighlight();
                mkDrop.updateMarker({
                    isActive: false,
                });
            }
            // 주문을 배차한 라이더
            if (mkWorkerOfAllocatedWorker) {
                mkWorkerOfAllocatedWorker.updateMarker();
            }
        });
        // 상점
        if (isDelete) {
            this.deleteMarker();
        }
        else {
            this.unhighlight();
            this.updateMarker({
                isActive: false,
                isHide,
            });
        }
    }
    /**
     * 스토어 마커 활성
     * @param storeData 상점 데이터
     */
    activateMarker() {
        // getterStoreList의 items는 숨김 설정 시 내 소속 허브 라이더에게 배차된 주문정보만 보여주기 위해
        // 숨김 설정 활성화일 때 내 소속 허브 라이더에게 배차된 주문정보만 담김
        // 숨김 설정 비활성화일 때는 state.storeList의 _items에 있는 모든 주문정보가 담김
        const storeData = this.mapControlGetters[mapControlGetterType.getterStoreList][this.storeId];
        const { items, } = storeData;
        const { isHideShareOrder, } = this.mapControlState.mapVisibilitySetting;
        Object.values(items).forEach((order) => {
            const { orderId } = order;
            const mkDrop = this.mapMarkerList.drops.getMarker(orderId);
            // 공유주문숨김시 접수상태건 제외.
            if (order.isShareOrder
                && isHideShareOrder
                && order.isAccepted) {
                return;
            }
            this.mapMarkerList.updateOrderMarkerWeight(orderId, false, true);
            // 주문
            mkDrop.highlight();
            mkDrop.updateMarker();
        });
        // 상점
        this.highlight();
        this.updateMarker({
            isActive: true,
        });
    }
    /**
     * 상점 + 도착지 노출 / 비노출 토글
     * @param {Object | null} mapInstance 네이버 지도 객체
     * @returns {number}
     */
    toggleVisibilityWithStoreOrder = (mapInstance = null) => {
        const { orderList, } = this.mapControlState;
        Object.values(orderList)
            .forEach((orderData) => {
            const { orderId } = orderData;
            if (!orderData) {
                return;
            }
            // TODO 기존에도 안쓰이던 코드. 추적관찰 후 제거
            // 특정 스토어의 주문을 필터링 후 한개라도 있으면 다음 로직, 0개면 노출 필요 x
            // 주문 필터링
            // if (filterId && this.isIncludedCurrentFilter(statusCode, filterId)) {
            //   return;
            // }
            const mkDrop = this.mapMarkerList.drops.getMarker(orderId);
            mkDrop.toggleVisibility(mapInstance);
        });
        super.toggleVisibility(mapInstance);
    };
}
